import React from "react";
import { Link } from "react-router-dom";
import "../Common/Common/Style.css"

const NotFound = () => {
  return (
    <div className="notFound">
      <h1 className="notFound__title">404</h1>
      <p className="notFound__message">Oops! The page you're looking for doesn't exist.</p>
      <Link to="/" className="notFound__link">
        Go Back to Home
      </Link>
    </div>
  );
};

export default NotFound;
